export default "__VITE_ASSET__a93d5652__"